export const handleInputChange = (e,setText,text,type) => {
    const { name, value } = e.target;
    setText({...text, [name]: value})
}